import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { LocaleProvider } from "../core/LocaleProvider";

export const registerComponentFn = (id, Component) => {
  const unmountComponent = () => {
    const domNode = document.getElementById(id);
    ReactDOM.unmountComponentAtNode(domNode);
  };

  window.rwgps[id] = (props) => {
    const domNode = document.getElementById(id);
    ReactDOM.render(
      <LocaleProvider>
        <Component unmountComponent={unmountComponent} {...props} />
      </LocaleProvider>,
      domNode
    );
    return { unmountComponent };
  };
};

export const registerComponentNode = (name, Component) => {
  window.rwgps[name] = (node, props) => {
    const unmountComponent = () => {
      ReactDOM.unmountComponentAtNode(node);
    };

    const instance = ReactDOM.render(
      <LocaleProvider>
        <Component unmountComponent={unmountComponent} {...props} />
      </LocaleProvider>,
      node
    );

    return { instance, unmountComponent };
  };
};

export const registerModalComponent = (name, Component) => {
  const id = `react-${name}`;
  const getDomNode = () => {
    const node = document.getElementById(id);
    if (node) {
      return node;
    }
    const div = document.createElement("div");
    div.id = id;
    document.body.appendChild(div);
    return div;
  };
  const unmount = () => {
    const node = getDomNode();
    ReactDOM.unmountComponentAtNode(node);
  };

  window.rwgps[name] = (props) => {
    const domNode = getDomNode();
    ReactDOM.render(
      <LocaleProvider>
        <BrowserRouter>
          <Component {...props} onRequestClose={unmount} />
        </BrowserRouter>
      </LocaleProvider>,
      domNode
    );
  };
};
